<template>
  <transition name="mei-message-fade">
    <div v-if="show" class="mei-message-container" @click="close">
      <div class="mei-message">
        <div :class="{'active':lang==='en'}" @click="changeLang('en')">English</div>
        <!-- <div @click="changeLang('zh')">简体中文</div> -->
        <div :class="{'active':lang==='sp'}"  @click="changeLang('sp')">Español</div>
        <div :class="{'active':lang==='fr'}"  @click="changeLang('fr')">Français</div>
        <div :class="{'active':lang==='de'}"  @click="changeLang('de')">Deutsch</div>
        <div :class="{'active':lang==='jp'}"  @click="changeLang('jp')">日本語</div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
const typeMap = {
  success: "success",
  info: "info",
  warning: "warning",
  error: "error"
};
export default {
  data() {
    return {
      show: false,
      text: "",
      lang:"en",
      type: "",
    };
  },
  computed: {
    iconClass() {
      return this.type ? `mei-message-icon mei-icon-${typeMap[this.type]}` : "";
    },
  },
  mounted(){
    this.lang = localStorage.locale ?  localStorage.locale : 'en';
  },
  methods: {
    close() {
      this.show = false;
    },
    changeLang(lang) {
      localStorage.setItem("locale", lang);
      this.lang = lang;
      this.close();
      location.reload();
    },
  },
};
</script>
<style lang="less" rel="stylesheet/scss" >
.mei-message-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999999;
  font-size: .56rem;
  background: rgba(0, 0, 0, 0.5);
}
.mei-message {
  position: fixed;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #2a2a2a;
  transition: opacity 0.3s, transform 0.4s;
  overflow: hidden;
  padding: 15px 15px 15px 20px;
  color: #ffffff;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  div {
    width: 47%;
    margin: 1%;
    height: 1rem;
    text-align: center;
    line-height:  1rem;
    border: 1px solid transparent;
    &.active {
      border: 1px solid #ffffff;
      border-radius: 9px;
    }
  }
}
// .mei-message-success {
//   background-color: rgb(87, 161, 87);
//   color: #fff;
// }
// .mei-message-error {
//   background-color: #ff5000;
//   color: #fff;
// }
// .mei-message-warning {
//   background-color: #ccc;
// }
// .mei-message-icon {
//   display: inline-block;
//   width: 40px;
//   height: 40px;
// }
.mei-message-con {
  line-height: 1rem;
  height: 1rem;
  display: inline-block;
  margin-left: 10px;
}
.mei-message-fade-enter-active {
  transition: all 0.3s linear;
}
.mei-message-fade-leave-active {
  transition: all 0.3s linear;
}
.mei-message-fade-enter, .mei-message-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>